/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCircleExclamationFill: {
  name: 'circle-exclamation-fill';
  data: string;
} = {
  name: 'circle-exclamation-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm1 7a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0V8Zm-1 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
